import { render, staticRenderFns } from "./StoreRestTimeManage.vue?vue&type=template&id=66064c25&scoped=true&"
import script from "./StoreRestTimeManage.vue?vue&type=script&lang=js&"
export * from "./StoreRestTimeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66064c25",
  null
  
)

export default component.exports